export default function addPageName(pageName) {
  return ctx => {
    if (!pageName) {
      throw new Error('addPageName middleware requires a page name argument');
    }
    if (ctx.pageName && ctx.pageName !== pageName) {
      throw new Error(`The context object already has the page name: ${ctx.pageName}`);
    }
    ctx.pageName = pageName;
  };
}